import api from "./baseApi";
import endpoints from "./endpoints";

// ================= GET PACKAGES =================

export const getPackages = async (params = {}) => {
  try {
    const res = await api.get(endpoints.package.base, {
      params: {
        page: params.page || 1,
        perPage: params.perPage || 10,
        sortField: params.sortField,
        sortOrder: params.sortOrder,
        ...(params.filters || {}),
      },
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch packages";
    throw new Error(message);
  }
};

// ================= GET PACKAGE BY ID =================

export const getPackageById = async (id) => {
  try {
    const res = await api.get(endpoints.package.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch package";
    throw new Error(message);
  }
};

// ================= CREATE PACKAGE =================

export const createPackage = async (payload) => {
  try {
    const res = await api.post(endpoints.package.base, payload);
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to create package";
    throw new Error(message);
  }
};

// ================= UPDATE PACKAGE =================

export const updatePackage = async (id, payload) => {
  try {
    const res = await api.put(endpoints.package.detail(id), payload);
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to update package";
    throw new Error(message);
  }
};

// ================= DELETE PACKAGE =================

export const deletePackage = async (id) => {
  try {
    const res = await api.delete(endpoints.package.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to delete package";
    throw new Error(message);
  }
};